import { forwardRef, type ButtonHTMLAttributes } from "react";
import { cx } from "./cx";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "ghost" | "danger";
  size?: "sm";
  /** 纯图标按钮，必须同时给 aria-label。 */
  iconOnly?: boolean;
  /** 右上角的计数角标，大于 0 才显示，超过 99 写 99+；角标对读屏隐藏，数量要写进 aria-label（决策 D205）。 */
  badge?: number;
}

/**
 * 按钮：默认 type=button；转发 ref，供需要移交焦点的场景（例如行内上移/下移到头后聚焦另一个箭头）。
 * 行内的危险操作（如移除一行）用幽灵按钮加类名 is-danger：平时是次要色，悬停或键盘聚焦时变危险色，不在每行放醒目的红色按钮。
 */
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button({ variant = "secondary", size, iconOnly, badge, className, type = "button", children, ...rest }, ref) {
  const badged = badge !== undefined && badge > 0;
  return (
    <button ref={ref} type={type} className={cx("ax-btn", `ax-btn-${variant}`, size === "sm" && "ax-btn-sm", iconOnly && "ax-btn-icon", badged && "ax-btn-badged", className)} {...rest}>
      {children}
      {badged && <span className="ax-btn-badge" aria-hidden>{badge > 99 ? "99+" : badge}</span>}
    </button>
  );
});
